import axios from "axios";

// 1 FE untuk beberapa BE: arahkan ke service disfo bila diisi,
// fallback ke BE utama bila masih monolit.
const API = axios.create({
  baseURL: process.env.REACT_APP_API_DISFO || process.env.REACT_APP_API_MASTER,
  headers: {
    "Content-Type": "application/json"
  }
});

API.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

class DisfoService {
  // auth (admin kelola)
  getContent() {
    return API.get("/content");
  }
  createContent(payload) {
    return API.post("/content", payload);
  }
  updateContent(id, payload) {
    return API.put(`/content/${id}`, payload);
  }
  deleteContent(id) {
    return API.delete(`/content/${id}`);
  }
  getRunningText() {
    return API.get("/running-text");
  }
  saveRunningText(payload) {
    return API.post("/running-text", payload);
  }
  // public (display board — tanpa token, controller tanpa auth)
  getPublicContent() {
    return API.get("/public/content");
  }
  getPublicRunningText() {
    return API.get("/public/running-text");
  }
}

export default new DisfoService();
